// ─── Site Configuration ───
// All text, colors, and content can be changed here.

export const SITE_CONFIG = {
  name: "My Health Directory",
  company: "Axxton Limited",
  tagline: "Find Your Healthcare Provider",
  description: "Find GP surgeries, dentists and pharmacies near you accepting new patients",
  searchPlaceholder: "Enter your postcode (e.g., SW1A 1AA)",
  contactEmail: "contact@my-health-directory.com",
  copyright: `© ${new Date().getFullYear()} Axxton Limited. All rights reserved.`,
};

export const NAV_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Search", href: "/search" },
  { label: "Claim a Listing", href: "/claim" },
  { label: "About", href: "/about" },
  { label: "Contact", href: "/contact" },
];

export const HOW_IT_WORKS = [
  {
    step: 1,
    title: "Enter your postcode",
    description: "Type in your UK postcode to find practices in your local area.",
    icon: "MapPin" as const,
  },
  {
    step: 2,
    title: "Browse practices near you",
    description: "View a list of nearby GP surgeries, dentists and healthcare providers.",
    icon: "Search" as const,
  },
  {
    step: 3,
    title: "View details",
    description: "Check opening hours, services and contact details.",
    icon: "CalendarCheck" as const,
  },
];

